import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { LoginPage } from '../features/auth/pages/LoginPage';
import { SignupPage } from '../features/auth/pages/SignupPage';
import { DashboardPage } from '../features/dashboard/pages/DashboardPage';
import { OrgManagementPage } from '../pages/OrgManagement';
import { SessionsPage } from '../pages/Sessions';
import { ForgotPasswordPage } from '../pages/ForgotPassword';
import { ResetPasswordPage } from '../pages/ResetPassword';
import { VerifyEmailPage } from '../pages/VerifyEmail';
import { AuthGuard, GuestGuard } from '../components/guards';
import { isSignupEnabled } from '../lib/feature-flags';

export const appRoutes = [
  // Guest routes — redirect to /dashboard if already authenticated
  <Route element={<GuestGuard />} key="guest">
    <Route path="/login" element={<LoginPage />} />
    {isSignupEnabled() && <Route path="/signup" element={<SignupPage />} />}
    {/* HZVT-150 — Password reset + email verification flows. These are
         intentionally guest-only because invoking them while logged in
         would be confusing UX and the underlying tokens are independent
         of the active session anyway. */}
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/verify-email" element={<VerifyEmailPage />} />
  </Route>,

  // Authenticated routes — redirect to /login if not authenticated
  <Route element={<AuthGuard />} key="auth">
    <Route path="/dashboard" element={<DashboardPage />} />
    <Route path="/organizations" element={<OrgManagementPage />} />
    {/* HZVT-149 — Active sessions / device management */}
    <Route path="/sessions" element={<SessionsPage />} />
  </Route>,

  // Root redirect
  <Route path="/" element={<Navigate to="/dashboard" />} key="root" />,

  // Catch-all — redirect unknown paths to /dashboard
  <Route path="*" element={<Navigate to="/dashboard" replace />} key="not-found" />,
];
